import Vue from "vue";
import Router from "vue-router";
import Index from "@/Index";
import Company from "@/Company";
import Automation from "@/Automation";
import Log from "@/Log";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/settings/:company",
      name: "ComapnySettings",
      component: Company
    },
    {
      path: "/automation/:company/:id?",
      name: "Automation",
      component: Automation,
    },
    {
      path: "/logs/:company/:id/:number?",
      name: "Log",
      component: Log,
    }
  ]
});
